// initial state
// shape: [{ id, quantity }]
const state = () => ({
	invitationcode: null,
	createdInvitationcode: null,
	invitationcodeModalOpen: false,
	auditorInvitationCodeModalOpen: false,
})

const getters = {
	getInvitationCodeModalOpen: (state) => {
		return state.invitationcodeModalOpen
	},
	getAuditorInvitationCodeModalOpen: (state) => {
		return state.auditorInvitationCodeModalOpen
	},
}

// actions
const actions = {
	setInvitationCode({ commit }, {invitationcode}) {
		commit("setInvitationCode", {invitationcode})
	},
	setCreatedInvitationCode({ commit }, {invitationcode}) {
		commit("setCreatedInvitationCode", {invitationcode})
	},
	setInvitationCodeModalOpen({ commit }, modalOpen) {
		commit("setInvitationCodeModalOpen", modalOpen)
	},
	setAuditorInvitationCodeModalOpen({ commit }, modalOpen) {
		commit("setAuditorInvitationCodeModalOpen", modalOpen)
	},
}

// mutations
const mutations = {
	setInvitationCode(state, {invitationcode}) {
		state.invitationcode = invitationcode
	},
	setCreatedInvitationCode(state, {invitationcode}) {
		state.createdInvitationcode = invitationcode
	},
	setInvitationCodeModalOpen(state, modalOpen) {
		state.invitationcodeModalOpen = modalOpen
	},
	setAuditorInvitationCodeModalOpen(state, modalOpen) {
		state.auditorInvitationCodeModalOpen = modalOpen
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}